// calc-utils.js


  
export const clearFormatting = (value) => {
  if (!value) return null; // Handle null or empty inputs
  // Remove dollar sign and percentage sign, then convert to a float
  const cleanedValue = parseFloat(value.replace(/[$,%]/g, ''));
  return isNaN(cleanedValue) ? null : cleanedValue;
};

export const formatCurrency = (value) => {
  return value ? `$${parseFloat(value.replace(/[$,%]/g, '')).toFixed(2)}` : '';
};

export const formatPercentage = (value) => {
  return value ? `${parseFloat(value.replace(/[$,%]/g, '')).toFixed(2)}%` : '';
};

export const handleBlurCurrency = (e, setFields) => {
  const { id, value } = e.target;
  setFields((prevFields) => ({ ...prevFields, [id]: formatCurrency(value) }));
};

export const handleBlurPercentage = (e, setFields) => {
  const { id, value } = e.target;
  setFields((prevFields) => ({ ...prevFields, [id]: formatPercentage(value) }));
};

export const handleFocus = (e, setFields) => {
  const { id, value } = e.target;
  setFields((prevFields) => ({ ...prevFields, [id]: value.replace(/[$,%]/g, '') }));
};